<template>
  <div>
    <v-icon
      class="onHover"
      :color="colors"
      right
      small
      title="Мой комментарий"
      style="margin: 0;"
      >comment</v-icon
    >
      <!-- @click="openDialog" -->
  </div>
</template>
<script>
export default {
  name: "bank_comments",
  components: {},
  data: () => ({
  }),
  props: {
    value: { type: Boolean, default: false , required: true},
    bank_id: {type: Number, default: null},
    product_id: {type: Number, default: null},
  },
  computed:{
    colors(){
      return this.value ? 'orange' : 'default'
    }
  },
  methods: {
    async openDialog(){
      this.$store.commit('setBankId',this.bank_id)
      this.$store.commit('setProductId',this.product_id)
      this.$router.push('/rating/userbank')
    },
  },
};
</script>
<style lang="sass" scoped>
.body
  max-height: 600px
  overflow: scroll
</style>
